// Turbo forces manual scroll restoration and records positions only at visit
// time, so a full browser reload restores a stale position after first paint,
// visible as a flicker and a jump. Track the live position and put reloads
// back exactly where the page was.
window.addEventListener('beforeunload', () => {
  sessionStorage.setItem('reloadScrollY', String(window.scrollY))
})

const nav = performance.getEntriesByType('navigation')[0]
if (nav?.type === 'reload') {
  const y = Number(sessionStorage.getItem('reloadScrollY') || 0)
  document.addEventListener('turbo:load', () => window.scrollTo(0, y), { once: true })
}
